var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.weixinShow
      ? _c("div", { staticClass: "is-weiXin-tip" }, [
          _c("img", {
            staticClass: "tip-open",
            attrs: {
              src: require("@/assets/imgs/common/what_tip1.png"),
              alt: ""
            }
          })
        ])
      : _c("div", { staticClass: "register-success-page" }, [
          _c("div", { staticClass: "register-success-warp" }, [
            _vm._m(0),
            _c("div", { staticClass: "register-success-container" }, [
              _c("div", { staticClass: "btn" }, [
                _c("button", { on: { click: _vm.buttonDownload } }, [
                  _vm._v("下载认证得法临币")
                ])
              ]),
              _c("p", { staticClass: "tip" }, [
                _vm._v("系统将在 "),
                _c("span", [_vm._v(_vm._s(_vm.counts) + "s")]),
                _vm._v(" 后跳转,若未跳转请手动 "),
                _c("span", [_vm._v("点击按钮跳转")])
              ])
            ])
          ])
        ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "register-header" }, [
      _c("img", {
        attrs: {
          src: require("@/assets/imgs/invitationPage/zhubiao@2x_2.png"),
          alt: ""
        }
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }